import { GridValueFormatterParams } from '@mui/x-data-grid-pro'

export const entityTypeValueFormatter = ({
  value,
}: GridValueFormatterParams): any => {
  if (!!value) {
    switch (value) {
      case 'DraftLead':
        return 'Pending Lead'
        break
      default:
        return value
    }
  }
}
